import { useState } from 'react';
import { updateProductCompetence } from '../../../api/configuracionSku';

export const useCompetencias = () => {
  const [actualizandoCompetencia, setActualizandoCompetencia] = useState({});
  const [competenciaLocal, setCompetenciaLocal] = useState({});

  // Función para actualizar el COMPETENCE de un producto
  const actualizarCompetencia = async (productoId, nuevoValor, mostrarToast) => {
    try {
      // Actualizar estado local inmediatamente para feedback visual
      setCompetenciaLocal(prev => ({
        ...prev,
        [productoId]: nuevoValor
      }));

      // Marcar como actualizando
      setActualizandoCompetencia(prev => ({
        ...prev,
        [productoId]: true
      }));

      const response = await updateProductCompetence(productoId, nuevoValor);

      // Mostrar notificación de éxito
      mostrarToast('success', `Competencia ${nuevoValor ? 'activada' : 'desactivada'} correctamente`);

    } catch (error) {
      console.error('Error al actualizar competencia:', error);
      // Revertir el cambio local en caso de error
      setCompetenciaLocal(prev => ({
        ...prev,
        [productoId]: !nuevoValor
      }));
      
      // Mostrar notificación de error
      mostrarToast('error', 'Error al actualizar la competencia');
    } finally {
      // Quitar el estado de actualizando
      setActualizandoCompetencia(prev => ({
        ...prev,
        [productoId]: false
      }));
    }
  };

  return {
    actualizandoCompetencia,
    competenciaLocal,
    actualizarCompetencia
  };
};
